export default __webpack_public_path__ + "static/media/over-the-phone.7ba882a8.svg";